import * as THREE from 'three';
import { G, M, TINT, HP, glowMat, mesh, mergeBones, stages, boneG } from './kit';
/* ============================================================
   FLUT 潮 —— BOSS・聚形
   ============================================================

   剪影：56 個立方體的雲
   階段：'P1 散成雲・打不完','P2 聚成錐・整根撞過來','P3 攤成牆・把場地切兩半'

   由 `tools/port-bosses.mjs` 從 `enemy_sample_ani.html` 機械移植，
   **不要手改這個檔**：要改造型請改原型再重跑移植器，否則 1:1 就斷了。
   驗證：`node tools/port-bosses.mjs --check`。
   ⚠️ 比對只守得住數字與字串，**動畫對不對只能實看**（圖鑑的開發模式）。 */


/* ── BOSS-13 FLUT 潮 ── 56 個立方體組成的雲，會聚成不同形狀。
   整隻 BOSS 是一顆 InstancedMesh —— 場上最大的東西，卻是最便宜的（1 draw call）。
   P1 散成一團雲，你打得到但打不完。
   P2 聚成一根 7 單位高的錐，整根撞過來。
   P3 攤平成一面 8×7 的牆，把場地切成兩半。 */
var FLN = 56, _fv = new THREE.Vector3(), _fq = new THREE.Quaternion(),
    _fe = new THREE.Euler(), _fs = new THREE.Vector3(), _fm = new THREE.Matrix4();
export function buildFlut(){
  var GL = glowMat(TINT.red.hex, 2.2);
  var root = new THREE.Group(), i;
  var im = new THREE.InstancedMesh(G.box, M.armor, FLN);
  im.userData.noMerge = 1; im.frustumCulled = false; root.add(im);
  var A = [], B = [], C = [];
  for (i = 0; i < FLN; i++){
    var a = i * 2.39996;                       // 黃金角：不用亂數也散得開
    var r = 2.6 + 2.6*Math.sqrt(i/FLN), t = i/FLN;
    A.push([Math.sin(a)*r, 2.2 + 2.8*Math.sin(i*1.7), Math.cos(a)*r]);
    B.push([Math.sin(a)*2.7*(1-t), 0.7 + t*6.6, Math.cos(a)*2.7*(1-t)]);
    C.push([((i % 8) - 3.5)*1.16, 0.85 + Math.floor(i/8)*1.06, 0]);
  }
  var core = boneG(root, 0, 3.20, 0);
  var cm = mesh(G.oct, GL, [1.50,1.50,1.50], [0,0,0]);
  cm.userData.noMerge = 1; core.add(cm);
  core.add(mesh(G.tor, M.trim, [2.30,2.30,0.34], [0,0,0], [HP,0,0]));
  root.userData.rig = {im:im, A:A, B:B, C:C, core:core, cm:cm, GL:GL};
  return mergeBones(root);
}
export function updFlut(rig, o, dt){
  stages(rig, o, dt, 1.5);
  var s1 = rig.s1, s2 = rig.s2, i;
  var wA = (1-s1), wB = s1*(1-s2), wC = s2;
  for (i = 0; i < FLN; i++){
    var a = rig.A[i], b = rig.B[i], c = rig.C[i];
    var jit = 0.45*wA + 0.10*wB;               // 雲的時候抖，聚形之後穩
    _fe.set(o.t*0.9 + i, o.t*0.7 + i*2, o.t*1.1 + i*3);
    _fq.setFromEuler(_fe);
    var k = 0.86 + 0.30*wB + 0.10*Math.sin(o.t*3 + i);
    _fm.compose(
      _fv.set(a[0]*wA + b[0]*wB + c[0]*wC + Math.sin(o.t*1.7 + i)*jit,
              a[1]*wA + b[1]*wB + c[1]*wC + Math.cos(o.t*1.3 + i*2)*jit,
              a[2]*wA + b[2]*wB + c[2]*wC + Math.sin(o.t*2.1 + i*3)*jit),
      _fq, _fs.set(k, k, k));
    rig.im.setMatrixAt(i, _fm);
  }
  rig.im.instanceMatrix.needsUpdate = true;
  rig.core.position.y = 3.20*wA + 3.60*wB + 3.40*wC;
  rig.cm.scale.setScalar((0.5 + 0.7*wA)*(1 + 0.14*Math.sin(o.t*2.8) + 0.8*o.tel));
  rig.core.rotation.y += dt*1.1;
  rig.GL.emissiveIntensity = 2.2 + 2.8*o.tel + 6*o.atk*(1-o.atk);
}